import React from "react";

import { UnprocessButton } from "./FooterButton";

/** Evoke roles in every state except Evoke Active. */
const EvokeProcessedButtons = ({ handleProcess }) => (
  <UnprocessButton onClick={() => handleProcess("unprocess")} />
);

export default EvokeProcessedButtons;
